export const START_PAYMENT_MODES = "START_PAYMENT_MODES";
export const ERROR_PAYMENT_MODES = "ERROR_PAYMENT_MODES";
export const SAVE_PAYMENT_MODES = "SAVE_PAYMENT_MODES";

export const START_RECORD_PAYMENT = "START_RECORD_PAYMENT";
export const ERROR_RECORD_PAYMENT = "ERROR_RECORD_PAYMENT";
export const SAVE_RECORD_PAYMENT = "SAVE_RECORD_PAYMENT";
